import { notification } from 'utils/services';
import readVisibleTable from './readVisibleTable';
import { withDesktopTables } from './printMode';
import buildTablePdf from './buildTablePdf';
import pdfFileName, { readFilterChips } from './pdfFileName';

// The page's own heading ("Retailers", "Visits"…), when the caller doesn't name the export.
const pageTitle = (root) => {
  const heading = Array.from(root.querySelectorAll('h1')).find((h) => h.textContent.trim());
  return heading ? heading.textContent.replace(/\s+/g, ' ').trim() : 'Export';
};

/**
 * Print / Save to PDF for the redesigned list pages: the table the user is looking at — this page of
 * rows, these columns, this tab — as a PDF named after the page and its applied filters, e.g.
 * "Retailers - City Boston, In business - 2026-10-05.pdf".
 *
 * Replaces newSavePageToPdf (a screenshot of the old design's markup) for list tables; that one
 * stays for the infographics, which are charts.
 */
const exportVisibleTablePdf = async ({ setExportLoading = () => {}, title, root = document } = {}) => {
  setExportLoading(true);
  try {
    // Read with every table showing its desktop layout, so a phone prints what a big screen does.
    const table = await withDesktopTables(() => readVisibleTable(root));
    if (!table || !table.columns.length) {
      notification.error('Switch to the list view to print this table.');
      return;
    }
    if (!table.rows.length) {
      notification.error('There are no rows to print.');
      return;
    }
    const name = title || pageTitle(root);
    const filters = readFilterChips(root);
    const doc = await buildTablePdf({ table, title: name, filters });
    doc.save(pdfFileName(name, filters));
  } catch {
    notification.error('The PDF could not be created. Please try again.');
  } finally {
    setExportLoading(false);
  }
};

export default exportVisibleTablePdf;
export { readVisibleTable, pdfFileName, readFilterChips };
